import { useRouter, useRoute } from 'vue-router'
const ecommerceOriginList = [
  'https://ecommerce.zaohaowu.com',
  'https://ecommerce-pre.zaohaowu.com',
  'https://ecommerce-qa.zaohaowu.net',
  'http://ecommerce.mm-test.com:9334'
]
export function useNavigate() {
  const router = useRouter()
  const route = useRoute()
  const isNeedHeader = () => {
    // 优先从 route.meta 取，如果没有则从 matched 最后一项的 meta 取
    let meta = route.meta

    if (!meta || Object.keys(meta).length === 0) {
      const matched = route.matched
      if (matched && matched.length > 0) {
        meta = matched[matched.length - 1].meta || {}
      }
    }
    return meta.needHeader !== false
  }
  const navigateTo = (url: string, openByNewTab: boolean = false) => {
    const urlObj = new URL(url, location.origin)
    if (!urlObj.origin) {
      router.push(urlObj.pathname + urlObj.search + urlObj.hash)
      return
    }
    if (ecommerceOriginList.includes(location.origin)) {
      if (!ecommerceOriginList.includes(urlObj.origin)) {
        // 电商跳转社区
        const communityUrl = window.__COMMUNITY_BASE_URL__
          ? window.__COMMUNITY_BASE_URL__ + urlObj.pathname + urlObj.search + urlObj.hash
          : url
        if (openByNewTab) {
          window.open(communityUrl, '_blank')
        } else {
          window.location.href = communityUrl
        }
        return
      }
    } else {
      if (ecommerceOriginList.includes(urlObj.origin)) {
        // 社区跳转电商
        const shopUrl = window.__SHOP_BASE_URL__
          ? window.__SHOP_BASE_URL__ + urlObj.pathname + urlObj.search + urlObj.hash
          : url
        if (openByNewTab) {
          window.open(shopUrl, '_blank')
        } else {
          window.location.href = shopUrl
        }
        return
      }
    }
    // 内部跳转
    router.push(urlObj.pathname + urlObj.search + urlObj.hash)
  }

  const navigateToIncentive = (params: {
    enterFrom: string
    pageName: 'task' | 'claim'
    taskId?: string
  }) => {
    if (isNeedHeader()) {
      router.replace({
        path: route.path,
        query: {
          ...route.query,
          wantEnterFrom: params.enterFrom,
          openWantLayer: params.pageName === 'task' ? 3 : 4,
          ...(params.taskId ? { wantTaskId: params.taskId } : {})
        }
      })
    } else {
      const searchParams = new URLSearchParams()
      searchParams.set('wantEnterFrom', params.enterFrom)
      searchParams.set('openWantLayer', params.pageName === 'task' ? '3' : '4')
      if (params.taskId) {
        searchParams.set('wantTaskId', params.taskId)
      }
      navigateTo(`https://zaohaowu.com/?${searchParams.toString()}`)
    }
  }
  return {
    navigateTo,
    navigateToIncentive,
    isNeedHeader
  }
}
